/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * Object contains review details like : rating, alias, headline, comment.
 * @export
 * @interface Review
 */
export interface Review {
    /**
     * Identifier of review
     * @type {string}
     * @memberof Review
     */
    id?: string;
    /**
     * Review headline
     * @type {string}
     * @memberof Review
     */
    headline?: string;
    /**
     * Review comment
     * @type {string}
     * @memberof Review
     */
    comment?: string;
    /**
     * Review rating value
     * @type {number}
     * @memberof Review
     */
    rating?: number;
    /**
     * Date of the review
     * @type {Date}
     * @memberof Review
     */
    date?: Date;
    /**
     * Alias name for the review
     * @type {string}
     * @memberof Review
     */
    alias?: string;
    /**
     * 
     * @type {User}
     * @memberof Review
     */
    principal?: User;
}

/**
 * Check if a given object implements the Review interface.
 */
export function instanceOfReview(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReviewFromJSON(json: any): Review {
    return ReviewFromJSONTyped(json, false);
}

export function ReviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): Review {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'headline': !exists(json, 'headline') ? undefined : json['headline'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'rating': !exists(json, 'rating') ? undefined : json['rating'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
        'principal': !exists(json, 'principal') ? undefined : UserFromJSON(json['principal']),
    };
}

export function ReviewToJSON(value?: Review | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'headline': value.headline,
        'comment': value.comment,
        'rating': value.rating,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'alias': value.alias,
        'principal': UserToJSON(value.principal),
    };
}

